import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Check, Trash2, Loader2, History } from "lucide-react";
import { formatEuro } from "@/lib/dates";
import { cn } from "@/lib/utils";

function fmtDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return "";
  }
}

export default function HistoryPanel() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    (async () => {
      const [used, wasted] = await Promise.all([
        api.get("/products?status=used"),
        api.get("/products?status=wasted"),
      ]);
      const all = [...used.data, ...wasted.data].sort(
        (a, b) => (b.resolved_at || "").localeCompare(a.resolved_at || "")
      );
      setItems(all);
    })();
  }, []);

  if (items === null)
    return <div className="flex justify-center py-16"><Loader2 className="h-5 w-5 animate-spin text-primary" /></div>;

  if (items.length === 0)
    return (
      <div className="text-center py-16 border border-dashed border-border rounded-2xl" data-testid="history-empty">
        <History className="h-7 w-7 mx-auto text-muted-foreground mb-3" />
        <p className="text-muted-foreground">Aucun produit archivé pour l’instant.</p>
      </div>
    );

  return (
    <div className="bg-card border border-border rounded-2xl overflow-hidden" data-testid="history-list">
      {items.map((it) => {
        const used = it.status === "used";
        return (
          <div key={it.id} className="flex items-center justify-between gap-3 px-4 py-3 border-b border-border last:border-b-0">
            <div className="flex items-center gap-3 min-w-0">
              <span className={cn("flex h-7 w-7 items-center justify-center rounded-full shrink-0",
                used ? "bg-primary/12 text-primary" : "bg-destructive/12 text-destructive")}>
                {used ? <Check className="h-4 w-4" /> : <Trash2 className="h-4 w-4" />}
              </span>
              <div className="min-w-0">
                <p className="font-medium truncate">{it.name}{it.quantity ? ` · ${it.quantity}` : ""}</p>
                <p className="mono text-[10px] uppercase tracking-mono text-muted-foreground">
                  {it.category} · {fmtDate(it.resolved_at)}
                </p>
              </div>
            </div>
            <div className="text-right shrink-0">
              <p className={cn("mono text-xs font-bold", used ? "text-primary" : "text-destructive")}>
                {used ? "Sauvé" : "Jeté"}
              </p>
              <p className="mono text-[10px] text-muted-foreground">{formatEuro(it.price)}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
